import { render, staticRenderFns } from "./local-promptpay.vue?vue&type=template&id=e13b9b72"
import script from "./local-promptpay.vue?vue&type=script&lang=js"
export * from "./local-promptpay.vue?vue&type=script&lang=js"
import style0 from "./local-promptpay.vue?vue&type=style&index=0&id=e13b9b72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports